import { render, staticRenderFns } from "./WebhookManagement.vue?vue&type=template&id=6ffeee50&scoped=true"
import script from "./WebhookManagement.vue?vue&type=script&lang=js"
export * from "./WebhookManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffeee50",
  null
  
)

export default component.exports